import type { CSSProperties } from "react";
import { useEffect, useState } from "react";
import { cn } from "../lib/utils";

interface WordRotateProps {
  words: string[];
  interval?: number; // ms
  prefix?: string;
  suffix?: string;
  className?: string;
  wordClassName?: string;
  style?: CSSProperties;
}

export function WordRotate({
  words,
  interval = 2000,
  prefix,
  suffix,
  className,
  wordClassName,
  style,
}: WordRotateProps) {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex(i => (i + 1) % words.length);
        setVisible(true);
      }, 300);
    }, interval);
    return () => clearInterval(timer);
  }, [words.length, interval]);

  return (
    <span className={cn("wr-root", className)} style={style}>
      {prefix && <span className="wr-static">{prefix} </span>}
      <span className={cn("wr-word", visible ? "wr-visible" : "wr-hidden", wordClassName)}>
        {words[index]}
      </span>
      {suffix && <span className="wr-static"> {suffix}</span>}
    </span>
  );
}
